import { Component, ElementRef, EventEmitter, Input, OnInit, Output, ViewChild } from '@angular/core';
import { Router } from '@angular/router';
import { AuthService } from '../../access/auth.service';
import { IProductList, Product } from '../../models/product-v2';
import { MessageService } from '../../util/message.service';
import { ModalService } from '../../util/modal.service';
import { ProductService } from '../../pages/members/product-v2/services/product.service';
import { ProductListItemVM } from '../../models/product-v3';
import { FeatureFlagService } from '../../util/feature-flag.service';
import { SkuListItemDto, SkuListItemVM } from '../../models/sku';



@Component({
  selector: 'skus-table',
  templateUrl: './skus-table.component.html',
  styleUrls: ['./skus-table.component.scss']
})
export class SkusTableComponent implements OnInit {

  @ViewChild('modal', { static: true }) modal!: ElementRef<HTMLDivElement>;
  @Input() isColaborator: boolean | undefined;
  @Input() isManager: boolean | undefined;
  @Input() subsidiary: any;
  @Input() actualSearch: any;
  @Input() selectedProduct: SkuListItemDto | undefined
  @Input() showOptions: boolean = true; // por defecto se muestran

  @Output() requestDelete = new EventEmitter<SkuListItemVM>();

  private storeId: string = '';
  isV2 = false;
  private _skus: SkuListItemVM[] = [];

  @Input()
  set skus(value: SkuListItemDto[]) {
    this._skus = (value ?? []).map(sku => ({
      id: sku.id,
      name: sku.name,
      sku: sku.skuRefId,
      ean: sku.ean,
      status: sku.status,
      productName: sku.product?.name ?? '',
      unitLabel: `${sku.unitMultiplier} ${sku.measurementUnit}`,
    }));
  }
  
  get skus(): SkuListItemVM[] {
    return this._skus;
  }
  constructor(
    private _route: Router,
    private _service: ProductService,
    private _auth: AuthService,
    private _modalService: ModalService,
    private _messageService: MessageService,
    private _featureFlag: FeatureFlagService
    
  ) { }
  
  public getMainImageUrl(images?: { url?: string; order?: number | string }[]): string {
    if (!images || !images.length) return '';
    const main = images.find(img => Number(img.order) === 0);
    return main?.url ?? images[0]?.url ?? '';
  }
  
  ngOnInit(): void {
    if(this._auth.getStore()) {
      this.storeId = this._auth.getStore().storeId;
      this.isV2 = this._featureFlag.isV2Store(this.storeId);

    }
  }

  editar(id: string) {
    console.log('id', id);
    this._route.navigate(
      ['/members/sku/detailSku', id],
    );
  }
  

  toggleOptions(e: HTMLImageElement | null) {
    // @ts-ignore
    let div: HTMLElement = e.parentElement
    if (div.classList.contains('options')) {
      // @ts-ignore
      div.querySelector('.box').classList.toggle('d-none')
    }

  }
  disableProduct(item: any) {
    this._service.disable(this.storeId, [item.category.id]).subscribe({
      next: () => {
        this._messageService.success('Producto deshabilitado correctamente.');
      },
      error: (e) => {
        this._messageService.error('Error al deshabilitar un producto.')
        this.error(e)
      }
    })
  }
  
  
  enableProduct(item: any) {
    this._service.enable(this.storeId, [item.category.id]).subscribe({
      next: () => {
        this._messageService.success('Producto hablitador correctamente.');
      },
      error: (e) => {
        this._messageService.error('Error al habilitar un producto.')
        this.error(e)
      }
    })
  }

  error(err: any) {
    if (err.error.detail) {
      this._modalService.showModalError('Ocurrio un error', err.error.detail.text)
    } else {
      this._modalService.showModalGenerico()
    }
  }

}
